import { render, staticRenderFns } from "./EditionDocTypes.vue?vue&type=template&id=6480f07f&"
import script from "./EditionDocTypes.vue?vue&type=script&lang=js&"
export * from "./EditionDocTypes.vue?vue&type=script&lang=js&"
import style0 from "./EditionDocTypes.vue?vue&type=style&index=0&id=6480f07f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports